var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_mouse-square",
    "data-name": "vuesax/linear/mouse-square",
    transform: "translate(-556 -636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mouse-square",
    transform: "translate(556 636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.667,20.833v-6.25C41.667,4.167,37.5,0,27.083,0h-12.5C4.167,0,0,4.167,0,14.583v12.5C0,37.5,4.167,41.667,14.583,41.667h6.25",
    transform: "translate(4.167 4.167)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.562,10.048l-3.4,1.146a3.136,3.136,0,0,0-2,2l-1.146,3.4A3.158,3.158,0,0,1,4,16.527L.146,4.131A3.165,3.165,0,0,1,4.1.152L16.521,4.006A3.18,3.18,0,0,1,16.562,10.048Z",
    transform: "translate(27.104 27.119)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H50V50H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmission);
export default __webpack_public_path__ + "static/media/admission.0e6face0f65d1402374b1dbbfb40d269.svg";
export { ForwardRef as ReactComponent };